import React, { Component } from "react";
import { NavLink, Redirect } from "react-router-dom";
import CookieValue from "../utils/cookie_value";
import Icon from "@material-ui/core/Icon";

export default class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: props.loggedIn,
      userName: props.userName,
      userRole: props.userRole,
      userId: props.userId,
    };
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this.props !== prevProps) {
      this.setState({
        loggedIn: this.props.loggedIn,
        userName: this.props.userName,
        userRole: this.props.userRole,
        userId: this.props.userId,
      });
    }
  };

  renderNavbarLinks = () => {
    if (CookieValue()) {
      return (
        <>
          <li className="nav-item">
            <NavLink to="/syllabi" className="nav-link">
              Course Syllabi
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/events" className="nav-link">
              Events
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/users" className="nav-link">
              Users
            </NavLink>
          </li>
          {this.state.userRole == "ADMIN" ? (
            <li className="nav-item">
              <NavLink
                to="/dropdown_settings"
                className="nav-link d-flex align-items-center"
              >
                Dropdowns
                <Icon className="text-secondary">settings</Icon>
              </NavLink>
            </li>
          ) : (
            ""
          )}
          <li className="nav-item">
            <NavLink to="/logout" className="nav-link">
              Log Out
            </NavLink>
          </li>
        </>
      );
    } else {
      return (
        <ul className="navbar-nav">
          <li className="nav-item">
            <NavLink to="/sign_up" className="nav-link">
              Sign Up
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/log_in" className="nav-link">
              Log In
            </NavLink>
          </li>
        </ul>
      );
    }
  };

  render() {
    const { userId, userName, userRole, loggedIn } = this.state;
    const displayUserHtml = (
      <div>
        Logged in as:
        <a href={process.env.BASE_URL + "user/" + userId} className="link-dark">
          {" "}
          {userName}
        </a>
      </div>
    );

    return (
      <nav
        className="navbar navbar-expand-lg navbar-light"
        style={{ backgroundColor: "lightblue" }}
      >
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink to="/" className="nav-link">
                Home
              </NavLink>
            </li>
            {this.renderNavbarLinks()}
          </ul>
        </div>
        {loggedIn ? displayUserHtml : ""}
      </nav>
    );
  }
}
